import React from "react";

import { AddRounded } from "@mui/icons-material";
import Button from "../Button";
import "./styles.css";

import { ReactComponent as WhiteLogo } from "../../assets/logo/white-logo.svg";
import { Divider } from "@mui/material";

import { ReactComponent as Instagram } from "../../assets/socials/instagram.svg";
import { ReactComponent as Linkedin } from "../../assets/socials/linkedin.svg";
import { ReactComponent as YouTube } from "../../assets/socials/youtube.svg";

export default function Footer({ title, subtitle, ctaText, ctaAction }) {
  function FooterLink({ title, info }) {
    return (
      <div className="pb-1">
        <span>
          <span className="title" style={{ display: "inline" }}>
            {title}{" "}
          </span>
          {info}
        </span>
      </div>
    );
  }

  function Social({ icon, url }) {
    return <a href={url} target="_blank" rel="noreferrer" className="social-icon">{icon}</a>;
  }

  return (
    <footer className="mt-8">
      <div className="footer-container center">
        {title && <h1 className="mt-6 footer-title">{title}</h1>}
        {subtitle && <h4 className="mt-2 footer-subtitle">{subtitle}</h4>}
        {ctaText && (
          <Button.Main
            className="center mt-3 mb-6"
            onPress={ctaAction}
            text={ctaText}
            rightIcon={<AddRounded />}
          />
        )}

        <WhiteLogo className="footer-logo mb-1" />

        <h5 className="footer-subtitle">Conectando pessoas aos seus objetivos fitness</h5>

        <Divider flexItem className="my-5" />

        <div className="footer-links-section mb-6">
          <div style={{ width: "100%" }}>
            <h4 className="title mb-2">Contato</h4>
            <FooterLink title="WhatsApp: " info="+55 11 91982-9965" />
            <a className="footer-help-link" href="https://help.ginastee.com">Central de ajuda</a>
            <FooterLink title="E-mail: " info="adm@ginastee.com" />
          </div>

          <Divider orientation="vertical" flexItem />

          <div style={{ width: "100%" }}>
            <h4 className="title mb-2">Endereço</h4>
            <FooterLink title="Rua Rio Grande do Norte, 1435, Savassi, Belo Horizonte - MG" />
          </div>

          <Divider orientation="vertical" flexItem />

          <div style={{ width: "100%" }}>
            <h4 className="title mb-2">Redes Sociais</h4>
            <div className="social-icons">
              <Social
                icon={<Instagram />}
                url="https://www.instagram.com/ginastee.app/"
              />

              <Social
                icon={<YouTube />}
                url="https://www.youtube.com/@ginasteebr"
              />

              <Social
                icon={<Linkedin />}
                url="https://www.linkedin.com/company/ginastee/"
              />
            </div>
          </div>
        </div>

        <h5 className="mb-2 footer-description">
          © 2025 - Todos os direitos reservados
        </h5>

        <h5 className="mb-6 footer-description">
          CNPJ 62.032.121/0001-72
        </h5>
      </div>
    </footer>
  );
}
